import { render, staticRenderFns } from "./MobileGeneral.vue?vue&type=template&id=1ac18da6&scoped=true"
import script from "./MobileGeneral.vue?vue&type=script&lang=js"
export * from "./MobileGeneral.vue?vue&type=script&lang=js"
import style0 from "./MobileGeneral.vue?vue&type=style&index=0&id=1ac18da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac18da6",
  null
  
)

export default component.exports